// extracted by mini-css-extract-plugin
export default {"address":"Address_address__TRyIh","item":"Address_item__pTFCN","sub":"Address_sub__Jc3gY","detail":"Address_detail__G3wmP"};